import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'personasDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'personasDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'personasDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
